var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdcLogoSvg = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 176.71",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d1d3d5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.85,176.71V78.45H576.22A21.12,21.12,0,0,0,591.59,72a21.65,21.65,0,0,0,6.47-16.18,21.62,21.62,0,0,0-6.47-16.17,20.48,20.48,0,0,0-15.37-6.47H467.85V0H576.22c15.77,0,28.71,5.26,40,16.58,10.91,10.92,16.57,23.86,16.57,39.22S627.58,84.11,616.26,95a54.69,54.69,0,0,1-40,16.58h-74v65.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.05,176.71V175.5h-.81V.4h83.3c23.05,0,42.06,8.5,58.23,25.88S818,64.7,818,88.56c0,24.26-8.08,44.88-24.26,62.27s-35.18,25.88-58.23,25.88Zm34.37-33.16h48.12c12.94,0,24.67-5.26,34-16.17,9.3-10.52,13.75-23.46,13.75-38.82s-4.85-28.31-13.75-38.82c-9.3-10.92-21-16.18-34-16.18H687.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M917.91,176.71c-23,0-42-8.49-58.23-25.88s-24.26-38.42-24.26-62.27c0-24.27,8.09-44.89,24.26-62.28S894.86.4,917.91.4H1000V33.56H917.91c-12.94,0-24.66,5.26-34,16.18-9.3,10.51-13.75,23.45-13.75,38.82s4.85,28.3,13.75,38.82c9.3,10.91,21,16.17,34,16.17H1000v33.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423,175.9,315,42.46h0L289.12,10.51C283.87,4,277,.4,269.31.4H226.85l22.24,27.5h0l11.73,14.56h0l108,133.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.42,1.62h0l-.81-.81h-51c-7.68,0-14.56,3.64-19.81,10.11L0,176.71H54.19l108-133.44H184.8L203,65.91h0l55.8,68.74H111.2l-34,42.06h268.5Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdcLogoSvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdc-logo-svg.91fea2a823d333f6eec6dd18e4ea3349.svg";